var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8548",
    className: "IC_4L_main",
    d: "M18.486 35.036s-3.942-3.944-15.867-2.856V11.993c11.925-1.088 15.869 2.855 15.869 2.855v20.186h-.003z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8549",
    className: "IC_4L_main",
    d: "M34.35 15.929v16.25c-11.921-1.092-15.863 2.856-15.863 2.856V14.846a10.94 10.94 0 014.659-2.203"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8550",
    className: "IC_4L_sub",
    d: "M32.173 15.929h5.533a2.302 2.302 0 002.195-2.399V8.109a2.301 2.301 0 00-2.195-2.399H25.343a2.302 2.302 0 00-2.195 2.399v5.421a2.304 2.304 0 002.195 2.399h1.025l-1.87 4.303 7.673-4.303h.003z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8551",
    className: "IC_4L_dot",
    d: "M27.861 11.295a1.445 1.445 0 111.443-1.447v.004c0 .797-.646 1.443-1.443 1.443"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.2d4553de317b13f8bf3cb9110e3f8bc4.svg";
export { ForwardRef as ReactComponent };